import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    title: process.env.VUE_APP_TITLE,
    showModaAgendamentolSucesso: false,
    protocolo: '1234',
    servico: 'Cadastro de cidadão',
    polo: 'Centro',
    endereco: 'Rua Álves de Castro nº 272 - Centro - Maricá - RJ',
    horario: '23/03/2020 às 10:15',
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
